module.exports = __webpack_public_path__ + "static/media/Dr Lance - Picture.376dd369.jpg";